module.exports = __webpack_public_path__ + "img/img_hezuofang.edde88d7.png";